import React, { Component, Fragment } from 'react';
// eslint-disable-next-line no-restricted-imports
import { translate } from 'react-polyglot';
import { withRouter } from 'react-router';

import { ButtonIcon } from 'components/button';
import { Loader } from 'components/loader';
import { Modal } from 'components/modal';
import { I18n } from 'components/translate';
import DateHelper, { shortFormatDate } from 'helpers/Date';
import { stripPTag } from 'helpers/String';
import { UiService } from 'modules/ui';
import { UserManagerService } from 'modules/userManager';
import PropTypes from 'prop-types';

import UserDetailQuizInfo from './UserDetailQuizInfo';
import UserDetailService from './UserDetailService';

import './UserDetailQuiz.scss';

@translate()
@withRouter
export default class UserDetailQuiz extends Component {
  static propTypes = {
    t: PropTypes.func,
    location: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
        userId: PropTypes.string
      })
    })
  };

  constructor(props) {
    super(props);

    this.state = {
      sort: 'asc',
      content: [],
      detailModal: false,
      selectedContentIndex: null,
      loading: true
    };

    this.renderQuizData = this.renderQuizData.bind(this);
  }

  async componentDidMount() {
    const { sort } = this.state;
    const { params } = this.props.match;

    try {
      const content = await UserManagerService.getQuizResult(params.userId);

      this.sortContent(content, sort);
      this.setState({ content, loading: false });
    } catch (error) {
      UiService.setAlertError('default_error');
      this.setState({ loading: false });
    }
  }

  sortContent = (content, sort) => {
    content.sort((a, b) => {
      const c = new Date(a.doneDate);
      const d = new Date(b.doneDate);

      return sort === 'asc' ? c - d : d - c;
    });
  };

  changeSort = () => {
    const { content, sort } = this.state;
    const changedSort = sort === 'desc' ? 'asc' : 'desc';

    this.sortContent(content, changedSort);
    this.setState({ sort: changedSort });
  };

  showQuizInfo = (index) => {
    this.setState({ detailModal: true, selectedContentIndex: index });
  };

  closeQuizInfo = () => {
    this.setState({ detailModal: false, selectedContentIndex: null });
  };

  renderContentOrEmptyContent(content) {
    return content.length ? this.renderContent() : this.renderEmptyContent();
  }

  renderQuizInfo() {
    const { selectedContentIndex, content } = this.state;

    return (
      <Modal
        onClose={this.closeQuizInfo}
        fullSize
        className="user_detail_quiz__anwsers-modal"
      >
        <Modal.Header>
          {(context) => (
            <Fragment>
              <ButtonIcon
                className="close"
                transparent
                type="secondary"
                icon="close"
                onClick={context.actions.closeModal}
              />
              <h2 className="modal_title">
                <I18n label="users_manager.users_detail.quiz_title" />
              </h2>
            </Fragment>
          )}
        </Modal.Header>
        <Modal.Body scrollable>
          <UserDetailQuizInfo quiz={content[selectedContentIndex]} />
        </Modal.Body>
      </Modal>
    );
  }

  renderQuizData(item, index) {
    return (
      <tr>
        <td data-header={`${this.props.t('general.date')}:`}>
          {DateHelper.formatDate(item.doneDate, shortFormatDate)}
        </td>
        <td data-header={`${this.props.t('general.quiz')}:`}>{item.title}</td>
        <td data-header={`${this.props.t('general.result')}:`}>
          {UserDetailService.isQuizProfile(item)
            ? stripPTag(item.quizProfile.name)
            : this.renderHitsFromTotal(item)}
        </td>
        <td data-header={`${this.props.t('general.status')}:`}>
          {item.quizResult && (
            <span
              className="result_info"
              onClick={() => this.showQuizInfo(index)}
            >
              <I18n label="general.see_answers" />
            </span>
          )}
        </td>
      </tr>
    );
  }

  renderHitsFromTotal({ quizResult, hitPercentage, hits }) {
    if (!quizResult) {
      return <I18n label="users_manager.users_detail.did_not_answer" />;
    }

    return (
      <I18n
        data={{ hitPercentage, hits, totalResult: quizResult.length }}
        label="users_manager.users_detail.hits_from_total"
      />
    );
  }

  renderContent() {
    const { content, sort } = this.state;

    return (
      <table>
        <thead>
          <tr>
            <th>
              <span
                onClick={this.changeSort}
                className={`arrow_${sort === '' ? 'sort' : sort}`}
              >
                <I18n label="general.date" />
              </span>
            </th>
            <th>
              <I18n label="general.quiz" />
            </th>
            <th>
              <I18n label="general.result" />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>{content.map(this.renderQuizData)}</tbody>
      </table>
    );
  }

  renderEmptyContent() {
    return (
      <div className="empty_quiz">
        <I18n label="general.no_result_found" />
      </div>
    );
  }

  render() {
    const { detailModal, content, loading } = this.state;

    return (
      <div className="user_detail_quiz">
        <h2>
          <I18n label="users_manager.users_detail.quiz_title" />
        </h2>
        {loading && <Loader key="loader" mask />}
        {!loading && this.renderContentOrEmptyContent(content)}
        {detailModal && this.renderQuizInfo()}
      </div>
    );
  }
}
